import { Box, Text} from '@chakra-ui/react';

const Footer = () => {
    return(
        <Box w="100%" h="auto">
            <Box display="flex" alignItems="center" 
                flexDirection="column" 
                 backgroundColor="#373737" 
                 color="#FFFFFF"
                 padding="20px 25px 28px 25px"
                 borderTop="2px"
                 borderTopColor="#FFFFFF"
            >
                    <Text 
                        textAlign={["center"]} 
                        fontSize={["12px","12px"]} 
                        lineHeight="15.18px" 
                        padding="14px 20px 25px 20px"
                        >
                       Consulta CAT, términos, condiciones, comisiones y requisitos en www.bancoppel.com | BanCoppel S.A. Institución de Banca Múltiple es una persona moral distinta a Coppel S.A. de C.V., así como de cualquiera de sus negocios asociados o vinculados. Los contenidos de esta publicidad únicamente tienen una finalidad informativa y/o meramente ilustrativa sobre la oferta de productos de dos empresas independientes entre sí | Para hacer uso de la banca electrónica, el cliente deberá firmar el contrato de servicios digitales.
                    </Text>
                    <Box p="2px 10px">
                        <a style={{ color: "white", fontSize: "12px", textDecoration: "underline"}} href="https://www.bancoppel.com/acerca_bancoppel/aviso.html" target="_blank"> Aviso de privacidad </a>
                    </Box>
            </Box>
        </Box>
    )
}

export default Footer;